import { DependencyList, useEffect, useRef, useState } from 'react';

export function useHorizontalOverflow<T extends HTMLElement>(deps: DependencyList) {
  const ref = useRef<T | null>(null);
  const [hasOverflow, setHasOverflow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let raf = 0;
    const measure = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const current = ref.current;
        if (!current) return;
        // allow 1px fuzz for subpixel layout
        setHasOverflow(current.scrollWidth > current.clientWidth + 1);
      });
    };

    measure();

    const ro = new ResizeObserver(() => measure());
    ro.observe(el);

    return () => {
      cancelAnimationFrame(raf);
      ro.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { ref, hasOverflow };
}
